"use client";

import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import { IRetailerProductBasedCollectionResponse } from "@faire/web-api--source/indigofair/data/IRetailerProductBasedCollectionResponse";
import { ISearchBrandsV2Response } from "@faire/web-api--source/indigofair/data/ISearchBrandsV2Response";
import { createContextStore } from "@faire/web/common/hooks/ContextStore";
import { ReactNode } from "react";
import React from "react";

export interface AppSignUpPageResults {
  productTiles?: Array<ILeanProductTile | undefined>;
  suppliersPageBrands?: Array<ISearchBrandsV2Response.IBrand>;
  pdpProduct?: IProductPageResponse.IPdpProduct;
  productBasedCollection?: IRetailerProductBasedCollectionResponse.IRetailerProductBasedCollection;
}

const INITIAL_CONTEXT_VALUE: AppSignUpPageResults = {};

const { useStore, Provider } = createContextStore<AppSignUpPageResults>(
  INITIAL_CONTEXT_VALUE
);

export const AppSignUpPageResultsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <Provider>{children}</Provider>;
};

export const TestAppSignUpPageResultsProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: Partial<AppSignUpPageResults>;
}) => {
  return <Provider value={value}>{children}</Provider>;
};

export const useAppSignUpPageResults = (): AppSignUpPageResults => {
  const [state] = useStore([
    "productTiles",
    "suppliersPageBrands",
    "pdpProduct",
    "productBasedCollection",
  ]);
  return state;
};

export const useAppSignUpPageResultsUpdateEffect = (
  results: Partial<AppSignUpPageResults>
): void => {
  const [_, setContext] = useStore([]);

  const {
    productTiles,
    suppliersPageBrands,
    pdpProduct,
    productBasedCollection,
  } = results;
  React.useEffect(() => {
    setContext({
      productTiles,
      suppliersPageBrands,
      pdpProduct,
      productBasedCollection,
    });
  }, [
    setContext,
    productTiles,
    suppliersPageBrands,
    pdpProduct,
    productBasedCollection,
  ]);

  React.useEffect(() => {
    return () => {
      // When page unmounts, let data be garbage collected.
      setContext(INITIAL_CONTEXT_VALUE);
    };
  }, [setContext]);
};
